import { render, staticRenderFns } from "./IntegrationBox.vue?vue&type=template&id=f27cb354&scoped=true&"
import script from "./IntegrationBox.vue?vue&type=script&lang=js&"
export * from "./IntegrationBox.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationBox.vue?vue&type=style&index=0&id=f27cb354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27cb354",
  null
  
)

export default component.exports